import React, { createContext, useEffect } from "react";
import { useGetAuthedUser } from "@nerdbord/graphql-api";
export var AuthContext = createContext({
    user: {},
    retryAuth: function () { },
    isLoading: false,
});
export var AuthProvider = function (_a) {
    var children = _a.children, initialUser = _a.initialUser;
    var _b = useGetAuthedUser(initialUser), user = _b.user, loading = _b.loading, refetch = _b.refetch, subscribeToUser = _b.subscribeToUser;
    useEffect(function () {
        user.id && subscribeToUser(user.id);
    }, [user.id]);
    return (React.createElement(AuthContext.Provider, { value: {
            user: user,
            isLoading: loading,
            retryAuth: refetch,
        } }, children));
};
